/**
 * 浏览器标签页上的站点图标(favicon)该用哪个。规则是纯函数,有单元测试;往 <head> 里写的那一步是 applySiteIcon。
 * - 平台身份(不是机构站点)、或没开白标的机构:平台图标(public/ 下的两张 PNG);
 * - 开了白标的机构:有自己的 Logo 就用它的 Logo;没有 Logo 就不出图标 —— 白标站点不能露出平台的图标;
 * - 站点信息还没取到(或这一页根本不取站点信息):不知道是不是白标机构,先不出图标 —— 宁可空着。
 * index.html 里静态写的也是「不出图标」(同一个空地址),所以脚本跑起来之前也不会露出平台的图标。
 */
export interface SiteIcon {
  /** <link rel="icon"> */
  icon: string;
  /** <link rel="apple-touch-icon">(添加到主屏幕用的大图) */
  touch: string;
}
export interface SiteIconBrand {
  /** 是不是机构站点(平台站点 = false) */
  isOrg: boolean;
  /** 这一页生效的白标:后台页看「后台白标」,其余页看「站点白标」 */
  whiteLabel: boolean;
  /** 机构在这一页所属的面上的 Logo(审核通过的);没有 = null */
  logoUrl: string | null;
}

export const PLATFORM_ICON: SiteIcon = Object.freeze({
  icon: '/favicon.png',
  touch: '/apple-touch-icon.png',
});
/** 「不出图标」:给一个空的 data 地址,浏览器就不会再去请求默认的 /favicon.ico */
export const NO_ICON = 'data:,';

export function siteIconFor(b: SiteIconBrand | null): SiteIcon | null {
  if (!b) return null;
  if (!b.isOrg || !b.whiteLabel) return PLATFORM_ICON;
  const logo = b.logoUrl?.trim();
  return logo ? { icon: logo, touch: logo } : null;
}

/** 把结果写到 <head>:改已有的 <link>,没有就补一个;「不出图标」时 icon 换成空地址、apple-touch-icon 整个拿掉 */
export function applySiteIcon(doc: Document, v: SiteIcon | null): void {
  // 平台图标是 PNG;机构的 Logo 什么格式都可能,不写 type 让浏览器自己认
  setLink(doc, 'icon', v ? v.icon : NO_ICON, v?.icon === PLATFORM_ICON.icon ? 'image/png' : null);
  setLink(doc, 'apple-touch-icon', v ? v.touch : null, null);
}

function setLink(doc: Document, rel: string, href: string | null, type: string | null): void {
  let el = doc.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (href === null) {
    el?.remove();
    return;
  }
  if (!el) {
    el = doc.createElement('link');
    el.setAttribute('rel', rel);
    doc.head.appendChild(el);
  }
  if (type) el.setAttribute('type', type);
  else el.removeAttribute('type');
  if (el.getAttribute('href') !== href) el.setAttribute('href', href);
}
